/**
 * Human-readable display labels for experiment status and enrollment type.
 * Stored values (e.g. in_progress, by_request) stay as-is in the API; these are for UI only.
 */

const STATUS_LABELS: Record<string, string> = {
  todo: "Todo",
  in_progress: "In Progress",
  inprogress: "In Progress",
  done: "Done",
  archived: "Archived",
  active: "Active",
  open: "Open",
  draft: "Draft",
  completed: "Completed",
  closed: "Closed",
  cancelled: "Cancelled",
  canceled: "Cancelled",
};

const ENROLLMENT_LABELS: Record<string, string> = {
  open: "Open",
  by_request: "By Request",
  closed: "Closed",
  internal_only: "Internal Only",
};

function toTitleCase(value: string): string {
  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatExperimentStatus(value: string | undefined | null): string {
  if (value == null || value === "") return "—";
  const key = value.toLowerCase().trim();
  return STATUS_LABELS[key] ?? toTitleCase(value);
}

export function formatEnrollmentType(value: string | undefined | null): string {
  if (value == null || value === "") return "—";
  const key = value.toLowerCase().trim();
  return ENROLLMENT_LABELS[key] ?? toTitleCase(value);
}
